import getPlatform from '@/helpers/getPlatform';
import { ProductItemTypes } from '../_types/productItem.types';
import intrack from '@/helpers/intrack';
const useHouseAnalytics = isMidTerm => {
  const intrackHouseView = (product: ProductItemTypes) => {
    if (!product) return;
    const houseAttributes = {};
    houseAttributes['house_id'] = product?.id;
    houseAttributes['house_title'] = product?.title;
    houseAttributes['number_of_rooms'] = product?.spaces?.normal_rooms + product?.spaces?.master_rooms || 0;
    houseAttributes['city_name'] = product?.location?.city;
    houseAttributes['province_name'] = product?.location?.province;
    houseAttributes['instant_reserve'] = product?.is_instant;
    houseAttributes['per_night_price'] = (product?.pricing?.price_to_show?.amount as number) / 1000;
    houseAttributes['platform'] = getPlatform();
    if (product?.rates?.rank) {
      houseAttributes['rate'] = product?.rates?.rank;
    }
    if (product?.landscape) {
      houseAttributes['landscape'] = product?.landscape;
    }

    // ------------------ Date & Guests Attribute ------------------
    if (localStorage.getItem('basicFilters')) {
      const {
        checkin,
        checkout,
        guests
      } = JSON.parse(localStorage.getItem('basicFilters') as string);
      if (checkin) {
        houseAttributes['check_in'] = new Date(+checkin * 1000); // format Eg: Sat Nov 26 2023 03:30:00 GMT+0330 (Iran Standard Time)
      }
      if (checkout) {
        houseAttributes['check_out'] = new Date(+checkout * 1000); // format Eg: Sat Nov 28 2023 03:30:00 GMT+0330 (Iran Standard Time)
      }
      if (checkin && checkout) {
        houseAttributes['number_of_nights'] = Math.round(Math.abs((new Date(+checkout * 1000) as any) - (new Date(+checkin * 1000) as any)) / (24 * 60 * 60 * 1000));
      }
      if (guests) {
        houseAttributes['number_of_guests'] = +guests;
      }
    }
    // ------------------ Date & Guests Attribute End ------------------

    // ------------------ Type Attribute ------------------
    const houseTypes = {
      villa: 'ویلا',
      apartment: 'آپارتمان',
      room: 'سوئیت',
      // by productbase check
      cottage: 'کلبه',
      boomgardi: 'بوم گردی'
    };
    if (houseTypes[product?.type as string]) {
      houseAttributes['type'] = houseTypes[product?.type as string];
    }
    // ------------------ Type Attribute End ------------------

    // ------------------ Features Attribute ------------------
    const houseFeatures: string[] = [];
    if (product?.rules?.records?.ceremony_allowed === 1) {
      houseFeatures.push('امکان برگزاری مراسم');
    }
    if (product?.rules?.records?.pets_allowed === 1) {
      houseFeatures.push('امکان ورود حیوانات خانگی');
    }
    if (product?.features?.filled_categories?.spaces?.find(item => item.feature_name === 'parking')) {
      houseFeatures.push('پارکینگ');
    }
    if (product?.features?.filled_categories?.spaces?.find(item => item.feature_name === 'pool')) {
      houseFeatures.push('استخر');
    }
    if (product?.features?.filled_categories?.amenities?.find(item => item.feature_name === 'wifi_internet')) {
      houseFeatures.push('اینترنت رایگان');
    }
    if (product?.features?.filled_categories?.spaces?.find(item => item.feature_name === 'hot_tub') || product?.features?.filled_categories?.amenities?.find(item => item.feature_name === 'bathtub')) {
      houseFeatures.push('جکوزی');
    }
    if (houseFeatures.length) {
      houseAttributes['features'] = houseFeatures.join(', '); // Convert To String
    }
    // ------------------ Features Attribute End ------------------
    if (isMidTerm) {
      houseAttributes['is_midterm'] = isMidTerm;
    }
    intrack.track('house_view', houseAttributes);
  };
  return {
    intrackHouseView
  };
};
export default useHouseAnalytics;